import { Building2, GraduationCap, Guitar, ShoppingBag, Disc3, type LucideIcon } from 'lucide-react';

/**
 * Tipos del directorio + sus labels/iconos/colores.
 * Fuente única de verdad — antes estaban inline en DirectoryIndex.tsx.
 */
export type DirectoryType = 'school' | 'rehearsal' | 'store' | 'club' | 'hub';

export const DIRECTORY_TYPES: DirectoryType[] = ['school', 'rehearsal', 'store', 'club', 'hub'];

export const TYPE_ICONS: Record<string, LucideIcon> = {
  school: GraduationCap,
  rehearsal: Guitar,
  store: ShoppingBag,
  club: Disc3,
  hub: Building2,
};

export const TYPE_LABELS: Record<string, string> = {
  school: 'Escuela de Música',
  rehearsal: 'Local de Ensayo',
  store: 'Tienda de Música',
  club: 'Club de Música',
  hub: 'Espacio Musical',
};

export const TYPE_COLORS: Record<string, string> = {
  school: '#047857',
  rehearsal: '#4F46E5',
  store: '#B45309',
  club: '#DC2626',
  hub: '#0F766E',
};

export const TYPE_CTAS: Record<string, string> = {
  school: 'Ver clases',
  rehearsal: 'Ver salas',
  store: 'Ver tienda',
  club: 'Ver club',
  hub: 'Ver espacio',
};
